import ErrorFormatService from '../../services/error-format-service';
import {
  GET_DEAL_LIST_DATA_SUCCESS, SAVE_DEAL_LIST_FILE_SUCCESS, DELETE_ACTIVITY_COMMENT_SUCCESS,
  SAVE_ACTIVITY_COMMENT_SUCCESS, SAVE_DEAL_STATUS_LIST_SUCCESS, GET_DEAL_LIST_DATA,
  SAVE_DEAL_STATUS_LIST, SAVE_DEAL_STATUS_LIST_ERROR, GET_LIST_CONTACT_PERSON_DATA_SUCCESS,
  GET_LIST_CONTACT_COMPANY_DATA_SUCCESS, GET_LIST_CONTACT_PERSON_INTERNAL_DATA_SUCCESS, SAVE_DEAL_LIST_FILE,
  GET_DEAL_STATUS_CHANGE_LIST_DATA, GET_DEAL_STATUS_CHANGE_LIST_DATA_SUCCESS,
  DELETE_DEAL_LIST_SUCCESS, SAVE_DEAL_LIST_DATA, SAVE_DEAL_LIST_DATA_SUCCESS, SAVE_DEAL_LIST_DATA_ERROR,
  SAVE_DEAL_LIST_FILE_ERROR, UPDATE_FILE_DEAL_LIST_SUCCESS, UPDATE_FILE_DEAL_LIST, UPDATE_FILE_DEAL_LIST_ERROR,
  RESET_DEAL_STATUS_CHANGE_LIST_DATA, LOGIN_USER_SUCCESS, LOGOUT_USER_SUCCESS, RESET_FORM_ERRORS,
  GET_LIST_TAG_DATA_SUCCESS,
} from '../../constants/system/actions';

const dealListReducer: Reducer = (
  state: ReducerState = {
    dealListData: null,
    dealStatusChangeListData: null,
    formErrors: {},
    isFormSaving: false,
    isLoading: false,
    isDealStatusChangeListLoading: false,
  },
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case GET_DEAL_LIST_DATA:
      return {
        ...state,
        isLoading: action.payload && !!action.payload.page,
      };
    case GET_DEAL_LIST_DATA_SUCCESS:
      return {
        ...state,
        dealListData: action.payload && action.payload.page ? {
          ...action.data,
          dealList: [...((
            state.dealListData && state.dealListData.dealList
            && state.dealListData.dealList.map((dealStatusItem: DealStatus): DealStatus => {
              const newDealGroup: DealStatus = action.data.dealList.find((newDealStatusItem: DealStatus): boolean => (
                newDealStatusItem.id === dealStatusItem.id
              ));

              if (newDealGroup) {
                return {
                  ...dealStatusItem,
                  deals: [
                    ...dealStatusItem.deals,
                    ...newDealGroup.deals.filter((newDealItem: Deal): boolean => (
                      !dealStatusItem.deals.find((dealItem: Deal): boolean => newDealItem.id === dealItem.id)
                    )),
                  ],
                };
              }

              return dealStatusItem;
            })
          ) || []), ...(
            state.dealListData && state.dealListData.dealList
              ? action.data.dealList.filter((newDealStatusItem: DealStatus): boolean => (
                !state.dealListData.dealList.find((dealStatusItem: DealStatus): boolean => (
                  newDealStatusItem.id === dealStatusItem.id
                ))
              )) : action.data.dealList
          )],
        } : action.data,
        isLoading: false,
      };
    case SAVE_DEAL_STATUS_LIST_SUCCESS:
    case SAVE_DEAL_LIST_FILE_SUCCESS:
    case UPDATE_FILE_DEAL_LIST_SUCCESS:
      return {
        ...state,
        isFormSaving: false,
        dealListData: action.data.dealListData,
      };
    case SAVE_DEAL_LIST_DATA:
    case SAVE_DEAL_STATUS_LIST:
    case SAVE_DEAL_LIST_FILE:
    case UPDATE_FILE_DEAL_LIST:
      return {
        ...state,
        formErrors: {},
        isFormSaving: true,
      };
    case SAVE_DEAL_LIST_DATA_SUCCESS:
      return {
        ...state,
        dealListData: action.data.dealListData,
        formErrors: {},
        isFormSaving: false,
      };
    case SAVE_DEAL_LIST_DATA_ERROR:
    case SAVE_DEAL_LIST_FILE_ERROR:
      if (!action.error) {
        return {
          ...state,
          isFormSaving: false,
        };
      }

      return {
        ...state,
        formErrors: ErrorFormatService.isFormError(action.error)
          ? ErrorFormatService.formatGraphQLErrors({ ...action.error })
          : ErrorFormatService.formatGraphQLMainError({ ...action.error }),
        isFormSaving: false,
      };
    case SAVE_DEAL_STATUS_LIST_ERROR:
    case UPDATE_FILE_DEAL_LIST_ERROR:
      return {
        ...state,
        isFormSaving: false,
      };
    case DELETE_DEAL_LIST_SUCCESS:
      return {
        ...state,
        dealListData: action.data.dealListData,
      };
    case DELETE_ACTIVITY_COMMENT_SUCCESS:
    case SAVE_ACTIVITY_COMMENT_SUCCESS:
      if (!state.dealListData) {
        return state;
      }

      return {
        ...state,
        dealListData: {
          ...state.dealListData,
          dealList: state.dealListData.dealList.map((
            dealStatusItem: DealStatus, dealGroupIndex: number,
          ): DealStatus => ({
            ...dealStatusItem,
            deals: state.dealListData.dealList[dealGroupIndex].deals.map((dealItem: Deal): Deal => ({
              ...dealItem,
              newDealActivity: (
                dealItem.newDealActivity
                && dealItem.newDealActivity.id === action.data.activityId && action.data.updatedData ? ({
                  ...dealItem.newDealActivity,
                  updatedDate: action.data.updatedData.updatedDate,
                  updatedDateText: action.data.updatedData.updatedDateText,
                  updatedByUserText: action.data.updatedData.updatedByUserText,
                  comments: action.data.comments,
                  attachments: action.data.attachments,
                }) : dealItem.newDealActivity
              ),
            })),
          })),
        },
      };
    case GET_DEAL_STATUS_CHANGE_LIST_DATA:
      return {
        ...state,
        isDealStatusChangeListLoading: true,
      };
    case GET_DEAL_STATUS_CHANGE_LIST_DATA_SUCCESS:
      return {
        ...state,
        dealStatusChangeListData: action.data.dealStatusChangeList,
        isDealStatusChangeListLoading: false,
      };
    case GET_LIST_CONTACT_PERSON_DATA_SUCCESS:
      if (!state.dealListData) {
        return state;
      }

      return {
        ...state,
        dealListData: {
          ...state.dealListData,
          contactPersonList: action.data,
        },
      };
    case GET_LIST_CONTACT_COMPANY_DATA_SUCCESS:
      if (!state.dealListData) {
        return state;
      }

      return {
        ...state,
        dealListData: {
          ...state.dealListData,
          contactCompanyList: action.data,
        },
      };
    case GET_LIST_CONTACT_PERSON_INTERNAL_DATA_SUCCESS:
      if (!state.dealListData) {
        return state;
      }

      return {
        ...state,
        dealListData: {
          ...state.dealListData,
          contactPersonInternalList: action.data,
        },
      };
    case GET_LIST_TAG_DATA_SUCCESS:
      if (!state.dealListData) {
        return state;
      }

      return {
        ...state,
        dealListData: {
          ...state.dealListData,
          tagList: action.data,
        },
      };
    case RESET_DEAL_STATUS_CHANGE_LIST_DATA:
      return {
        ...state,
        dealStatusChangeListData: null,
        isDealStatusChangeListLoading: false,
      };
    case RESET_FORM_ERRORS:
      return {
        ...state,
        formErrors: {},
      };
    case LOGIN_USER_SUCCESS:
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        dealListData: null,
        dealStatusChangeListData: null,
        formErrors: {},
        isFormSaving: false,
        isLoading: false,
        isDealStatusChangeListLoading: false,
      };
    default:
      return state;
  }
};

export default dealListReducer;
